import {createApolloClient} from "./graphql/apolloClient";
import {ApolloProvider} from "@apollo/client";
import {useToast} from "@chakra-ui/react";
import {FC, useCallback, useContext, useMemo} from "react";
import {AuthContext, AuthContextI} from "./auth/FirebaseAuth";

type Props = {
    children: any
}

export const ConnectionProvider: FC<Props> = ({children}) => {
    const authContext = useContext<AuthContextI>(AuthContext)
    const toast = useToast();
    const handleAuthError = useCallback(() => {
        const toastId = "session-expired";
        if (!toast.isActive(toastId)) {
            toast({
                id: toastId,
                title: "Session expired",
                description: "Please sign in again.",
                status: "warning",
                isClosable: true
            });
        }
        authContext.signOut();
    }, [authContext, toast]);

    const handleNetworkError = useCallback(() => {
        const toastId = "server-unreachable";
        if (!toast.isActive(toastId)) {
            toast({
                id: toastId,
                title: "Server unavailable",
                description: "Could not reach the server. Please check your connection and try again.",
                status: "error",
                duration: 8000,
                isClosable: true
            });
        }
    }, [toast]);

    const client = useMemo(() => (
        createApolloClient(authContext.getTokenAsync, authContext.refreshToken, handleAuthError, handleNetworkError)
    ), [authContext, handleAuthError, handleNetworkError]);

    return <ApolloProvider client={client}>{children}</ApolloProvider>
}
